/* bmb-fidelite — page du programme de fidelite.
   Deux roles : ouvrir le panneau Smile depuis nos boutons, et refleter le solde
   de points dans la barre de progression et les cartes de recompense.

   Le solde n'est pas disponible cote Liquid : Smile remplit lui-meme les elements
   portant la classe .sweettooth-points-balance, de facon asynchrone et apres le
   chargement de son SDK. On observe donc l'element au lieu de le lire une fois. */
(function () {
  'use strict';
  if (window.__bmbFidelite) return;
  window.__bmbFidelite = true;

  var MAX_ATTENTE = 20000;

  /* ---------- Ouverture du panneau Smile ---------- */

  function ouvrirPanneau(declencheur) {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel({ data: { trigger: 'page_fidelite' } });
      return;
    }
    // Le SDK se charge apres le reste de la page : on retente le temps qu'il arrive.
    var echeance = Date.now() + MAX_ATTENTE;
    var horloge = setInterval(function () {
      if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
        clearInterval(horloge);
        window.SmileUI.openPanel({ data: { trigger: 'page_fidelite' } });
      } else if (Date.now() > echeance) {
        clearInterval(horloge);
        if (declencheur) declencheur.disabled = true;
      }
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var declencheur = e.target.closest('[data-bmb-smile-open]');
    if (!declencheur) return;
    e.preventDefault();
    ouvrirPanneau(declencheur);
  });

  /* ---------- Lecture du solde ---------- */

  function lireSolde() {
    var cible = document.querySelector('.sweettooth-points-balance');
    if (!cible) return null;
    // Smile peut ecrire "2,000" ou "2 000" selon la locale.
    var chiffres = (cible.textContent || '').replace(/[^\d]/g, '');
    if (!chiffres) return null;
    return parseInt(chiffres, 10);
  }

  function surSolde(callback) {
    var valeur = lireSolde();
    if (valeur !== null) { callback(valeur); return; }

    var cible = document.querySelector('.sweettooth-points-balance');
    var fini = false;
    function tenter() {
      if (fini) return;
      var v = lireSolde();
      if (v === null) return;
      fini = true;
      if (observateur) observateur.disconnect();
      clearInterval(horloge);
      callback(v);
    }
    var observateur = cible && 'MutationObserver' in window
      ? new MutationObserver(tenter) : null;
    if (observateur) observateur.observe(cible, { childList: true, characterData: true, subtree: true });
    // Filet : certaines versions du SDK remplacent le noeud au lieu de l'editer.
    var horloge = setInterval(tenter, 400);
    setTimeout(function () {
      if (fini) return;
      fini = true;
      if (observateur) observateur.disconnect();
      clearInterval(horloge);
    }, MAX_ATTENTE);
  }

  /* ---------- Barre de progression ---------- */

  function majProgression(solde) {
    var carte = document.querySelector('[data-bmb-fid-solde]');
    if (!carte) return;
    var seuil = parseInt(carte.getAttribute('data-seuil'), 10);
    if (!seuil || seuil <= 0) return;

    var part = Math.max(0, Math.min(1, solde / seuil));
    var jauge = carte.querySelector('[data-bmb-fid-jauge]');
    if (jauge) jauge.style.width = (part * 100).toFixed(1) + '%';

    var barre = carte.querySelector('[data-bmb-fid-barre]');
    if (barre) barre.setAttribute('aria-valuenow', String(solde));

    var reste = carte.querySelector('[data-bmb-fid-reste]');
    if (!reste) return;
    var manque = seuil - solde;
    if (manque > 0) {
      var modele = carte.getAttribute('data-modele-reste') || '';
      reste.textContent = modele.replace('[points]', manque.toLocaleString());
    } else {
      reste.textContent = '';
    }
    reste.hidden = manque <= 0;
  }

  /* ---------- Etat des recompenses ---------- */

  function majRecompenses(solde) {
    var grille = document.querySelector('[data-bmb-fid-recompenses]');
    if (!grille) return;
    var gabaritManque = grille.getAttribute('data-manque') || '';
    var texteAtteint = grille.getAttribute('data-atteint') || '';

    grille.querySelectorAll('[data-cout]').forEach(function (carte) {
      var cout = parseInt(carte.getAttribute('data-cout'), 10);
      var etat = carte.querySelector('[data-bmb-fid-etat]');
      if (!etat || !cout) return;
      if (solde >= cout) {
        carte.classList.add('est-atteinte');
        etat.textContent = texteAtteint;
      } else {
        carte.classList.remove('est-atteinte');
        etat.textContent = gabaritManque.replace('[points]', (cout - solde).toLocaleString());
      }
    });
  }


  /* ---------- Revelations au scroll ----------
     IntersectionObserver plutot qu'un ecouteur scroll : pas de travail par frame,
     et l'observation s'arrete des que l'element est apparu. */

  function reveler() {
    var cibles = document.querySelectorAll('.bmb-fid-reveal');
    if (!cibles.length) return;

    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduit || !('IntersectionObserver' in window)) {
      cibles.forEach(function (n) { n.classList.add('est-visible'); });
      return;
    }

    var observateur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (entree) {
        if (!entree.isIntersecting) return;
        entree.target.classList.add('est-visible');
        observateur.unobserve(entree.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    cibles.forEach(function (n) { observateur.observe(n); });

    /* Filet : un defilement tres rapide, un saut d'ancre ou un onglet en arriere-plan
       peuvent faire manquer une notification. Passe ce delai, plus rien ne reste
       masque — l'animation est un bonus, jamais une condition d'affichage. */
    setTimeout(function () {
      cibles.forEach(function (n) {
        if (n.classList.contains('est-visible')) return;
        n.classList.add('est-visible');
        observateur.unobserve(n);
      });
    }, 4000);
  }

  function demarrer() {
    reveler();
    if (!document.querySelector('.sweettooth-points-balance')) return;
    surSolde(function (solde) {
      majProgression(solde);
      majRecompenses(solde);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
